import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  content: {
    padding: '20px 30px',
    height: '100%',
    width: '100%',
    backgroundColor: theme.palette.common.white,
    overflow: 'hidden',
    [theme.breakpoints.down('md')]: {
      padding: '20px'
    }
  },
  addLocationContainer: {
    marginBottom: '1rem'
  },
  gridContainer: {
    height: 600
  },
}));
